<template>
  <div>
  <v-dialog v-model="props.editZoneDialog" persistent width="800px">
    <v-card>
      <v-card-title class="d-flex justify-start" style="position: relative">
        <v-row class="mb-4">
          <h2>{{this.props.client.name}} and zone on {{this.props.zone.name}}</h2>
        </v-row>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="$emit('cancel-change')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              label="Choose Service..."
              :items="services"
              item-text="name"
              return-object
              v-model="selectedService"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="end"  v-show="isInternalUser">
          <v-col cols=7>
            <h4>Choose the time windows you want to add to this Zone</h4>
          </v-col>
          <v-spacer></v-spacer>
<!--          <v-col cols="auto">-->
<!--            <v-tooltip top color="secondary">-->
<!--              <template v-slot:activator="{ on }">-->
<!--                <v-btn @click="newDay" class="mx-2" fab dark color="blue lighten-1" v-on="on">-->
<!--                  <v-icon dark>add</v-icon>-->
<!--                </v-btn>-->
<!--              </template>-->
<!--              <span>add the day on this zone for client {{this.props.client.name}}</span>-->
<!--            </v-tooltip>-->
<!--          </v-col>-->
        </v-row>
        <v-divider color="#42a5f5"></v-divider>

        <v-list scrollable style="height: 400px; overflow: scroll" v-if="selectedService !== null">
          <v-list-group
            v-for="day in Object.keys(renderedTimeWindows)"
            :key="day"
          >
            <template v-slot:activator >
              <v-list-item  >
                <v-list-item-content>
                  <v-list-item-title  class="font-weight-bold">{{day}}</v-list-item-title>
                </v-list-item-content>

<!--                 Delete Button-->
<!--                <v-list-item-action  v-show="isInternalUser">-->
<!--                  <v-btn icon @click.stop="deleteDay(day)"-->
<!--                         :disabled="hasSelectedTimeWindow(day)" >-->
<!--                    <v-icon color="red">mdi-delete</v-icon>-->
<!--                  </v-btn>-->
<!--                </v-list-item-action>-->

              </v-list-item>
            </template>

            <v-list-item
              v-for="(tw, index) in renderedTimeWindows[day]"
              :key="index"
            >
              <v-list-item-action>
                <v-checkbox
                  @change="timeWindowSelected(tw)"
                  v-model="tw.selected"
                ></v-checkbox>
              </v-list-item-action>

              <v-list-item-content @click.prevent="tw.selected = !tw.selected">
                <v-list-item-title :style="tw.restricted ? 'color: red' : 'color: black'">
                  {{tw.time_start}} - {{tw.time_end}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>

      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text color="blue-grey lighten-2" @click="$emit('cancel-change')">Cancel</v-btn>
        <v-btn text v-on:click="$emit('save-change', renderedTimeWindows)" color="blue darken-1">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="deleteDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="justify-center">
        <h3>ATTENTION</h3>
      </v-card-title>
      <v-card-text class="text-center">
        You are about to delete this day. This action cannot be undone. <br>
        Are you sure you want to proceed ?
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
        <v-btn text @click="triggerDelete" color="blue darken-1">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    <v-dialog v-model="addDayDialog"  width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{'New Day'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="addDayDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-container container--fluid grid-list-xl pb-0>

            <v-row justify="center">
              <v-col cols="12" md="4">
                <v-select
                  :items="days"
                  item-text="name"
                  return-object
                  v-model="newSpecialDay"
                  prepend-icon="fas fa-calendar"
                  label="Day..."></v-select>
              </v-col>
            </v-row>


            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" md="3" class="text-center">
                <v-btn
                  text
                  @click="addDayDialog=false"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <v-btn
                  text
                  @click="saveDay"
                  color="blue darken-1"
                >Save
                </v-btn>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>



  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "EditZoneDialog",
        props: {
            props: Object,
        },
        data() {
            return {
                days: [
                    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
                ],
                client_days: [
                  'Monday', 'Tuesday', 'Wednesday', 'Thursday','Friday','Saturday', 'Sunday'
                ],
                selectedService: null,
                deleteDialog:false,
                toBeDeleted:null,
                addDayDialog:false,
                newSpecialDay:null
            }
        },
        computed: {
          renderedClientDays(){
            if (Array.isArray(this.client_days)) {
              return this.client_days;
            } else {
              //return JSON.parse(this.client_days);
              return [];
            }
          },
          renderedTimeWindows() {
              // Taking ids of tw already present for this zone
              let alreadyTwId = [];
              if (this.timeWindows !== undefined) {
                  alreadyTwId = this.timeWindows.filter((tw) => {
                      return tw.in_use;
                  });
                  alreadyTwId = alreadyTwId.map((tw) => {
                      return tw.id
                  });
              }
              let rendered = {};
                this.renderedClientDays.forEach(day => {
                  rendered[day] = [];
                });
              for (var i = 0; i < this.props.timeWindows.length; i++) {
                  if (alreadyTwId.includes(this.props.timeWindows[i].id)) {
                      this.props.timeWindows[i].selected = true;
                  } else {
                      this.props.timeWindows[i].selected = false;
                  }

                  if (!rendered.hasOwnProperty( this.props.timeWindows[i].day)) {
                    continue;
                  }
                  rendered[this.props.timeWindows[i].day].push(this.props.timeWindows[i]);
              }

              return rendered
          },
          isInternalUser() {
            return this.$store.getters['auth/isInternalUser']  &&  this.$store.getters['auth/hasPermission']('zone_edit');
          },

        },
        watch: {
          renderedClientDays(newVal) {
            if (Array.isArray(newVal) && newVal.length > 0) {
              this.renderedTimeWindows;
            }
          }
        },
        asyncComputed: {
            // @vuese
            // Gets all the services for a specific client.
            async services() {
                console.log("Load Services");
                if (this.props.client !== null) {
                    this.selectedService = null;
                    return await axios.get(process.env.API_URL + '/clients/' + this.props.client.id
                        + '/services?zone=' + this.props.zone.id)
                        .then((response) => {
                            console.log("Got " + response.data.length + " services");
                            if (response.data.length === 1) {
                                this.selectedService = response.data[0];
                            }
                            return response.data;
                        })
                        .catch((error) => {
                            console.log(error.response.error)
                        });
                } else return [];
            },

            async timeWindows() {
                console.log("Load Time Windows");
                if (this.props.zone !== null && this.selectedService !== null) {
                    return await axios.get(process.env.API_URL + '/clients/' + this.props.client.id
                        + '/services/' + this.selectedService.id + '/zones/' + this.props.zone.id + '/timewindows')
                        .then((response) => {
                            console.log("Got " + response.data.length + " timeWindows");
                            return response.data;
                        })
                        .catch((response) => {
                            this.$emit('error' + 'ERROR ' + response.response.data.error);
                        });
                } else return [];
            },

          // async client_days() {
          //   console.log("Load client zone day");
          //   if (this.props.zone !== null && this.selectedService !== null) {
          //     return await axios.get(process.env.API_URL + '/clients/' + this.props.client.id
          //       + '/services/' + this.selectedService.id + '/zones/' + this.props.zone.id + '/days')
          //       .then((response) => {
          //         console.log("Got " + response.data.length + " days");
          //         // return JSON.parse(response.data);
          //         const daysArray = JSON.parse(response.data).replace(/\[|\]/g, '').split(',');
          //         return daysArray.map(day => day.replace(/"/g, '').trim());
          //       })
          //       .catch((response) => {
          //         this.$emit('error' + 'ERROR ' + response.response.data.error);
          //       });
          //   } else return [];
          // },

        },
        methods: {
            timeWindowSelected(tw) {
                if (tw.selected) {
                    axios.post(process.env.API_URL + '/clients/' + this.props.client.id + '/zones/' + this.props.zone.id
                        + '/timewindows/' + tw.id + '/services/' + this.selectedService.id)
                        .then((response) => {
                            tw.selected = true;
                        })
                        .catch((response) => {
                            console.log(response.response.data.error);
                            this.$emit('error', 'ERROR ' + response.response.data.error);
                            tw.selected = !tw.selected;
                        })
                } else {
                    axios.delete(process.env.API_URL + '/clients/' + this.props.client.id + '/zones/' + this.props.zone.id
                        + '/timewindows/' + tw.id + '/services/' + this.selectedService.id)
                        .then((response) => {
                            tw.selected = false;
                        })
                        .catch((response) => {
                            console.log(response.response.data.error);
                            this.$emit('error', 'ERROR ' + response.response.data.error);
                            tw.selected = !tw.selected;
                        })
                }
            },
          deleteDay(day){
            this.toBeDeleted = day;
            this.deleteDialog = true;
          },
          triggerDelete(){
            if (this.client_days.includes(this.toBeDeleted)) {
              this.client_days = this.client_days.filter(item => item !== this.toBeDeleted);
            }

            let data = {
              clientId: this.props.client.id,
              serviceId: this.selectedService.id,
              zoneId: this.props.zone.id,
              days: this.client_days
            };
            axios.post(process.env.API_URL + '/clients/' + this.props.client.id
              + '/services/' + this.selectedService.id + '/zones/' + this.props.zone.id + '/days', data)
              .then((response) => {
                this.$store.commit('displaySnackbar', 'Successfully updated client zone days settings');
                this.toBeDeleted = null;
              })
              .catch((error) => {
                alert('Failed to update client zone days ');
              });

            this.deleteDialog = false;
          },
          newDay(){
             this.addDayDialog= true;
          },
          saveDay(){
            console.log("chao ni ");
            if (!this.client_days.includes(this.newSpecialDay)) {
              this.client_days.push(this.newSpecialDay);
            } else {
              this.$store.commit('displaySnackbar', 'Already into client zone days');
              return;
            }

            let data = {
              clientId: this.props.client.id,
              serviceId: this.selectedService.id,
              zoneId: this.props.zone.id,
              days: this.client_days
            };
            axios.post(process.env.API_URL + '/clients/' + this.props.client.id
              + '/services/' + this.selectedService.id + '/zones/' + this.props.zone.id + '/days', data)
              .then((response) => {
                this.$store.commit('displaySnackbar', 'Successfully updated client zone days settings');
                this.newSpecialDay = null;
              })
              .catch((error) => {
                alert('Failed to update client zone days ');
              });

            this.addDayDialog= false;

          },
          hasSelectedTimeWindow(day) {
            return this.renderedTimeWindows[day].some(tw => tw.selected);
          },

        },
        mounted() {
        }
    }
</script>

<style scoped>

  .v-card__title {
    word-break: keep-all;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/EditZoneDialog.vue